export let ExperimentKeys;
(function (ExperimentKeys) {
  ExperimentKeys["ACQ0177"] = "acq-0177";
})(ExperimentKeys || (ExperimentKeys = {}));
export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';